import axios from "@/axios";

export const namespaced = true

// const defaultData = {
//     acsaAgreementId: 0,
//     countryId: 0,
//     name: null,
//     remark: null,
//     files: []
// }

export const state = {
    acsaAgreement: {
        acsaAgreementId: 0,
        countryId: 0,
        name: null,
        remark: null,
        files: []
    },
    acsaAgreements: [],
    countryAcsaAgreement: {
        acsaAgreementId: 0,
        countryId: 0,
        name: null,
        remark: null,
        files: []
    },
    paginatedAcsas: []
}

export const getters = {        
        acsaAgreement: (state) => state.acsaAgreement,
        acsaAgreements: (state) => state.acsaAgreements,
        paginatedAcsas: (state) => state.paginatedAcsas,
        countryAcsaAgreement: (state) => state.countryAcsaAgreement,
}
    
export const mutations = {
    SET_ACSA_AGREEMENTS: (state, response) => (state.acsaAgreements = response.data),
    SET_PAGINATED_ACSAS: (state, response) => (state.paginatedAcsas = response.data),
    SET_COUNTRY_ACSA_AGREEMENT: (state, response) => (state.countryAcsaAgreement = response.data),
    SET_ACSA_AGREEMENT: (state, response) => (state.acsaAgreement = response.data),
}

export const actions = {

        async saveAcsaFile({dispatch},formData) {
            let response = await axios
            .post("/api/acsaagreementfiles/", formData)
            .then((response) => {
              dispatch("acsaAgreement", formData.get("agreementId"));
            })
            .catch((err) => {
              //console.log(err); //not handelled
            });


        },
        async getAllAcsaAgreements({commit}) {
            const response = await axios.get("/api/acsaagreements");
            commit('SET_ACSA_AGREEMENTS', response)
        },
        async getCountryAcsaAgreement({commit}, id) {
            const response = await axios.get(`/api/countries/agreement/${id}`);
            commit('SET_COUNTRY_ACSA_AGREEMENT', response)
        },
        async getAcsaAgreement({commit}, id) {
            const response = await axios.get(`/api/acsaagreements/${id}`);
            // debugger;

            commit('SET_ACSA_AGREEMENT', response)
    },

        async getPaginatedAcsas({ commit }, pageInfo) {
            commit('SET_PAGINATED_ACSAS', await axios.get(`/api/acsaagreements/admin/acsas/${pageInfo.pageNumber}/${pageInfo.pageCount}/${pageInfo.searchText}`))
        },
        async getPaginatedAcsasByCountry({ commit }, pageInfo) {
            commit('SET_PAGINATED_ACSAS', await axios.get(`/api/acsaagreements/admin/acsas/country/${pageInfo.countrySelection}/${pageInfo.pageNumber}/${pageInfo.pageCount}/${pageInfo.searchText}`))
    },

        async updateAcsa({ commit,state}) {
            
            await axios.post("/api/acsaagreements/", state.acsaagreement).then(() => {

                commit('SET_ACSA_AGREEMENT',{})
        });
        
    }
    
}
